import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import { Checkbox as MuiCheckbox, FormControlLabel, FormControl, FormHelperText } from '@material-ui/core'

interface CheckboxProps {
  name: string
  label: string
  disabled?: boolean
}

const Checkbox: React.FC<CheckboxProps> = ({ name, label, disabled = false }) => {
  const { control, errors } = useFormContext()
  const error = errors[name]

  return (
    <FormControl error={!!error} disabled={disabled}>
      <Controller
        name={name}
        control={control}
        defaultValue={false}
        render={({ onChange, onBlur, value, name: fieldName, ref }) => (
          <FormControlLabel
            control={
              <MuiCheckbox
                name={fieldName}
                inputRef={ref}
                checked={!!value}
                onChange={(_, checked) => onChange(checked)}
                onBlur={onBlur}
                color="primary"
              />
            }
            label={label}
          />
        )}
      />
      {error && <FormHelperText>{error.message}</FormHelperText>}
    </FormControl>
  )
}

export default Checkbox
